import type { GetStaticPaths, InferGetStaticPropsType } from 'next'

import { GridPageLayout } from '@/components/Layouts/GridPageLayout'
import { useInitTranslations } from '@/lib/hooks/initializers/useInitTranslations'
import Head from 'next/head'
import { getProductsStaticPaths } from '@/lib/staticPaths/getProductsStaticPaths'
import type { CosmicProductType } from '@/lib/cms/cosmic/types/CosmicProductType'
import type { CMSError } from '@/lib/cms/types/CMSError'
import { getGridPageBannerData } from '@/lib/utils/product/getGridPageBannerData'
import { getStaticProps } from './server'

export const getStaticPaths = (async () => ({
  paths: await getProductsStaticPaths(),
  fallback: 'blocking',
})) satisfies GetStaticPaths

export { getStaticProps }

const ProductsPage = ({
  productsBannerImageData,
  productCategoryData,
  products,
  translations,
  title,
  metaData,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  useInitTranslations({ translations })

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="twitter:card" content="summary_large_image" />
        {metaData &&
          metaData.map((metaElement) => (
            <meta
              property={metaElement.property}
              content={metaElement.content || undefined}
              key={metaElement.key}
            />
          ))}
      </Head>

      <GridPageLayout
        products={products as CosmicProductType[] | { error: CMSError } | null} // TODO: Do not assert type, fix this
        productsBannerImageData={getGridPageBannerData(
          productCategoryData,
          productsBannerImageData,
        )}
        productCategoryData={productCategoryData}
      />
    </>
  )
}

export default ProductsPage
